module.exports = __webpack_public_path__ + "img/introduce.b29fdcfe.jpg";